import React from "react";
import { X } from "lucide-react";
import { getStatusClass } from "../Layout/StatusStyle";

const DetailBox = ({ handleClose, selectedObject }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-[20px]  w-[85vw] max-h-[90vh] p-6 relative flex flex-col max-w-[800px]">
        <button
          onClick={handleClose}
          className="absolute -top-5 -right-7 sm:-right-10 bg-white rounded-full p-1 sm:p-2 shadow-md"
        >
          <X className="w-6 h-6 text-gray-600 hover:text-gray-800" />
        </button>
        <div>
          <h2 className="text-3xl font-bold mb-3 text-text1">Detail info</h2>
          <hr className="mt-4" />
        </div>
        <div className="mb-3">
          <div className="flex justify-between pt-3 pb-2.5">
            <p className="font-medium text-base text-text1">Patient details</p>
          </div>
          {[
            { label: "Patient name", value: selectedObject.patientname },
            { label: "Patient email", value: selectedObject.patientemail },
            {
              label: "Mobile Number",
              value: selectedObject.mobileNumber,
            },
          ].map(({ label, value }) => (
            <div key={label} className="flex justify-between py-3">
              <p className="font-medium text-base text-text3">{label}</p>
              <p className="font-medium text-base text-text1 text-right">
                {value || ""}
              </p>
            </div>
          ))}
        </div>
        <hr />
        <div className="mb-3">
          <div className="flex justify-between pt-3 pb-2.5">
            <p className="font-medium text-base text-text1">Product details</p>
          </div>
          {[
            { label: "Doctor name", value: selectedObject.doctorsname },
            { label: "Product code", value: selectedObject.product_code },
            {
              label: "Product name",
              value: selectedObject.product_name,
            },
            {
              label: "Quantity",
              value: selectedObject.quantity,
            },
            {
              label: "Status",
              value: selectedObject.tracking_status,
            },
          ].map(({ label, value }) => (
            <div key={label} className="flex justify-between py-3 gap-2">
              <p className="font-medium text-base text-text3 whitespace-nowrap">
                {label}
              </p>
              <p className="font-medium text-base text-text1 text-right">
                {label === "Status" ? (
                  <span className={getStatusClass(value)}>{value} </span>
                ) : (
                  value || ""
                )}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DetailBox;
